var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6001 12.6001C13.0971 12.6001 13.5001 13.003 13.5001 13.5001V24.3001H22.5001V13.5001C22.5001 13.003 22.903 12.6001 23.4001 12.6001C23.8971 12.6001 24.3001 13.003 24.3001 13.5001V24.3001C24.3001 25.2942 23.4942 26.1001 22.5001 26.1001H13.5001C12.506 26.1001 11.7001 25.2942 11.7001 24.3001V13.5001C11.7001 13.003 12.103 12.6001 12.6001 12.6001Z",
    fill: "#008C15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90002 12.6C9.90002 12.1029 10.303 11.7 10.8 11.7L25.2 11.7C25.6971 11.7 26.1 12.1029 26.1 12.6C26.1 13.097 25.6971 13.5 25.2 13.5L10.8 13.5C10.303 13.5 9.90002 13.097 9.90002 12.6Z",
    fill: "#008C15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 10.8C13.5 9.80589 14.3059 9 15.3 9H20.7C21.6941 9 22.5 9.80589 22.5 10.8V12.6C22.5 13.0971 22.0971 13.5 21.6 13.5C21.1029 13.5 20.7 13.0971 20.7 12.6V10.8H15.3V12.6C15.3 13.0971 14.8971 13.5 14.4 13.5C13.9029 13.5 13.5 13.0971 13.5 12.6V10.8Z",
    fill: "#008C15"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.3d4409727cd315e3bc58890b1be5db29.svg";
export { ForwardRef as ReactComponent };